import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateDeckCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const zipCode = identification.address.PostalCode;
  const { deck, craftsmanQuality, propertyType } = improvementsForTransaction;
  if (isUndefined(craftsmanQuality) || isUndefined(zipCode) || !deck || !propertyType) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  const params = deck.area
    ? {
        hasFeature: ORDER_FEATURES.deck.hasFeature(improvementsForTransaction),
        propertyType,
        type: deck.type,
        quality: deck.quality ?? craftsmanQuality,
        sqft: AloftArea.fromNumber(deck.area.unitAmount, deck.area.unit),
        zipCode,
      }
    : {
        hasFeature: ORDER_FEATURES.deck.hasFeature(improvementsForTransaction),
        propertyType,
        type: deck.type,
        quality: deck.quality ?? craftsmanQuality,
        zipCode,
      };

  return calculator.getDeckCost(params);
};

export const { selectDeckCost, selectZipOnlyDeckCost, selectDeckCosts, selectDeckCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculateDeckCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectDeckCost',
      zipOnly: 'selectZipOnlyDeckCost',
      costs: 'selectDeckCosts',
      display: 'selectDeckCostDisplay',
    },
  });
